// extracted by mini-css-extract-plugin
export default {"burger":"VojUz","icon":"tR_ur"};